/**
 * Split an imported config file into what to write and what to refuse.
 *
 * The endpoint no longer returns the prompt keys nothing this chat runs can read, so an
 * older, complete export carries keys the page does not have. Those are INACTIVE, not
 * unknown (`inactiveKeys` is the endpoint's `visibility.hidden_keys` for this tab): they
 * are dropped from the payload — the stored values stay, the endpoint restores them on
 * save — while a key nobody recognises is still refused.
 */
export function prepareConfigImport(imported, currentKeys, inactiveKeys = []) {
  const current = new Set(currentKeys);
  const inactive = new Set(inactiveKeys);
  const payload = {};
  const unknownKeys = [];
  const ignoredKeys = [];
  for (const [key, value] of Object.entries(imported)) {
    if (current.has(key)) payload[key] = value;
    else if (inactive.has(key)) ignoredKeys.push(key);
    else unknownKeys.push(key);
  }
  return { payload, unknownKeys, ignoredKeys };
}
